// src/Dashboard/pages/user/Inscription/components/InscriptionToolbar.jsx

import React from "react";
import { FaFilter, FaSearch } from "react-icons/fa";

export default function InscriptionToolbar({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  seasonFilter,
  setSeasonFilter,
  resultCount,
  totalCount,
  activeSeason,
}) {
  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="grid grid-cols-1 gap-3 xl:grid-cols-[minmax(0,1fr),220px,220px,auto] xl:items-end">
        <div>
          <label className="mb-1 flex items-center gap-2 text-sm font-bold text-slate-800 dark:text-slate-100">
            <FaSearch className="text-slate-400" />
            Recherche
          </label>

          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Rechercher un nom, prénom ou numéro de licence..."
            className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          />
        </div>

        <div>
          <label className="mb-1 flex items-center gap-2 text-sm font-bold text-slate-800 dark:text-slate-100">
            <FaFilter className="text-slate-400" />
            État du dossier
          </label>

          <select
            value={statusFilter}
            onChange={(event) => setStatusFilter(event.target.value)}
            className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value="all">Tous les états</option>
            <option value="up_to_date">Dossier à jour</option>
            <option value="missing">Documents à compléter</option>
            <option value="waiting">En attente de validation</option>
            <option value="renewal">Renouvellement à faire</option>
            <option value="no_dossier">Dossier à créer</option>
          </select>
        </div>

        <div>
          <label className="mb-1 block text-sm font-bold text-slate-800 dark:text-slate-100">
            Saison
          </label>

          <select
            value={seasonFilter}
            onChange={(event) => setSeasonFilter(event.target.value)}
            className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value="all">Toutes les saisons</option>
            <option value="current">Saison active {activeSeason || ""}</option>
            <option value="old">À renouveler</option>
          </select>
        </div>

        <div className="rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-700 ring-1 ring-slate-200 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700">
          {resultCount} / {totalCount} affiché{resultCount > 1 ? "s" : ""}
        </div>
      </div>
    </div>
  );
}